if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();

      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.dispatchMessage = this.querySelector('.js-inventory-urgency');
      this.variantInventory = JSON.parse(this.querySelector('[type="application/json"]').textContent);

      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) {
        this.updateInventory(0, false, '');
        return;
      }

      const inventory = this.variantInventory.find((row) => row.id === variant.id);
      if (!inventory) {
        this.clearInventory();
        return;
      }

      this.updateInventory(
        inventory.inventory_quantity,
        inventory.available,
        inventory.inventory_policy
      );
    }

    isBeforeDispatchCutoff() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date()).map((p) => [p.type, p.value])
      );

      const isWeekday = !['Sat', 'Sun'].includes(parts.weekday);
      return isWeekday && (Number(parts.hour) < 15
        || (Number(parts.hour) === 15 && Number(parts.minute) === 0));
    }

    clearInventory() {
      this.hidden = true;
      this.removeAttribute('data-inventory-level');
      if (this.inventoryNotice) this.inventoryNotice.innerText = '';
      if (this.dispatchMessage) this.dispatchMessage.innerHTML = '';
    }

    updateInventory(count, available, inventoryPolicy) {
      if (!inventoryPolicy && !available && count <= 0) {
        this.clearInventory();
        return;
      }

      const isInStock = available && count > 0;
      this.hidden = false;
      this.setAttribute('data-inventory-level', isInStock ? 'in_stock' : 'none');

      if (isInStock) {
        this.inventoryNotice.innerText = theme.strings.inStock;
        this.dispatchMessage.innerHTML = this.isBeforeDispatchCutoff()
          ? this.dataset.textNormal
          : '';
      } else {
        this.inventoryNotice.innerText = theme.strings.noStock;
        this.dispatchMessage.innerHTML = '';
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
